import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import DocumentsList from "@/pages/DocumentsList";
import DocumentEditor from "@/pages/DocumentEditor";
import DocumentView from "@/pages/DocumentView";
import Jobs from "@/pages/Jobs";
import Materials from "@/pages/Materials";
import Tools from "@/pages/Tools";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";

function Protected({ children }) {
  const { user } = useApp();
  if (user === null) {
    return <div className="min-h-screen grid place-items-center text-stone-500" data-testid="auth-loading">Cargando…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function docRoutes(type, base) {
  return [
    <Route key={`${base}-l`} path={base} element={<Protected><DocumentsList type={type} /></Protected>} />,
    <Route key={`${base}-n`} path={`${base}/nueva`} element={<Protected><DocumentEditor key={`${type}-new`} type={type} /></Protected>} />,
    <Route key={`${base}-e`} path={`${base}/:id/editar`} element={<Protected><DocumentEditor key={`${type}-edit`} type={type} /></Protected>} />,
    <Route key={`${base}-v`} path={`${base}/:id`} element={<Protected><DocumentView key={`${type}-view`} type={type} /></Protected>} />,
  ];
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          {docRoutes("sale", "/ventas")}
          {docRoutes("quote", "/cotizaciones")}
          <Route path="/agenda" element={<Protected><Jobs /></Protected>} />
          <Route path="/materiales" element={<Protected><Materials /></Protected>} />
          <Route path="/herramientas" element={<Protected><Tools /></Protected>} />
          <Route path="/reportes" element={<Protected><Reports /></Protected>} />
          <Route path="/configuracion" element={<Protected><Settings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AppProvider>
  );
}
